import { ChevronDown, Funnel } from "lucide-react"
import { FC } from "react"

type FilterToggleButtonProps = {
  active?: boolean
  onClick?: () => void
}

export const FilterToggleButton: FC<FilterToggleButtonProps> = ({ active, onClick }) => {
  const handleClick = () => {
    if (onClick) onClick()
  }

  return (
    <button onClick={handleClick} className={`flex items-center gap-2 px-6 py-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors`}>
      <Funnel className="w-5 h-5" />
      <div className="flex items-center gap-2">
        Filtros{''}
        <ChevronDown className={`w-4 h-4 transition-transform ${active ? 'rotate-180' : ''}`} />
      </div>
    </button>
  )
}

export default FilterToggleButton
